var _title, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFewClouds = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "var(--color--primary-text)"
    },
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "weather-cloud")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25,3a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V2A1,1,0,0,0,9.25,3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.416,4.83A1,1,0,1,0,4.83,3.416l-.707-.707A1,1,0,0,0,2.709,4.123Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3,9.25a1,1,0,0,0-1-1H1a1,1,0,0,0,0,2H2A1,1,0,0,0,3,9.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.377,5.123a1,1,0,0,0,.707-.293l.707-.707a1,1,0,0,0-1.414-1.414l-.707.707a1,1,0,0,0,.707,1.707Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.916,11.994a.249.249,0,0,0,.109-.38,4,4,0,0,1,6.343-4.867.253.253,0,0,0,.264.084A8.548,8.548,0,0,1,14.2,6.537a.25.25,0,0,0,.191-.378A6,6,0,1,0,4.279,12.606a.25.25,0,0,0,.346.068A6.939,6.939,0,0,1,5.916,11.994Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.094,15.074a.252.252,0,0,1-.1-.193A7,7,0,0,0,8.338,12.84a.249.249,0,0,1-.22.173A5.5,5.5,0,0,0,8.5,24H19a5,5,0,0,0,3.094-8.926ZM22,19a3,3,0,0,1-3,3H8.5a3.5,3.5,0,1,1,.448-6.971.994.994,0,0,0,1.116-.833A5,5,0,0,1,20,15c0,.146-.007.289-.02.433a1,1,0,0,0,.5.959A3.007,3.007,0,0,1,22,19Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFewClouds, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/few_clouds.2f5742f9.svg";
export { ForwardRef as ReactComponent };